import axios, { AxiosResponse } from 'axios';
import { init } from '@/mock';

import { ServerData } from '@/@types/base';

import {
  ApiPreAuthPayload,
  ApiPreAuthResponse,
  ApiPaymentPayload,
  ApiPaymentResponse,
  // ApiPricingData,
} from '@/@types/bankroll';

export async function preAuth(payload: ApiPreAuthPayload) {
  const response: AxiosResponse<ServerData<ApiPreAuthResponse>> = await axios({
    method: 'POST',
    url: '/user/pre-auth',
    data: payload,
  });

  const {
    data: { success, data: authData },
  } = response;

  if (!success) {
    throw new Error('api preAuth success false');
  }

  return authData;
}

export async function makePayment(payload: ApiPaymentPayload) {
  const response: AxiosResponse<ServerData<ApiPaymentResponse>> = await axios({
    method: 'POST',
    url: '/bankroll/webhook',
    data: payload,
  });

  const {
    data: { success, data: payment },
  } = response;

  if (!success) {
    throw new Error('api makePayment success false');
  }

  return payment;
}

export async function getPaymentPageData() {
  // const response: AxiosResponse<ServerData<ApiPricingData>> = await axios({
  //   method: 'POST',
  //   url: '/payment/page-api/getPaymentPageData/membership',
  // });

  // const {
  //   // data: { success, data: pricingData },
  //   data: { success },
  // } = response;

  // if (!success) {
  //   throw new Error('api getPaymentPageData success false');
  // }

  // return pricingData;
  return init;
}
